import { render, staticRenderFns } from "./NoteForm.vue?vue&type=template&id=75b97d64&scoped=true&"
import script from "./NoteForm.vue?vue&type=script&lang=js&"
export * from "./NoteForm.vue?vue&type=script&lang=js&"
import style0 from "./NoteForm.vue?vue&type=style&index=0&id=75b97d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b97d64",
  null
  
)

/* custom blocks */
import block0 from "./NoteForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports